// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__OyWWv","tab":"Tabs_tab__1okcz","tabActive":"Tabs_tabActive__3tbHC"};